module.exports = __webpack_public_path__ + "static/media/WarningDeleteUserIcon.25f87838.svg";